<!-- 口袋精灵绑定码绑定 -->
<template>
  <div class="container">
    <div class="detail">
      <div class="pic-box">
        <img :src="fairy.f_good_img" alt="" class="pic">
      </div>
      <div class="instruction">
        <h1 class="title">友悦宝舞蹈机器人绑定说明：</h1>
        <p class="intro">1. 机器人在联网状态下，长按“本地内容”键三秒即会播放绑定码；</p>
        <p class="intro">2. 把绑定码输入下方输入框，点击绑定设备按钮；</p>
        <p class="intro">3. 绑定成功。</p>
      </div>
    </div>
    <div class="bind">
      <input type="text" placeholder="请输入绑定码" class="code-input" v-model="code" :disabled="!fId">
      <div class="submit" @click="submit">绑定设备</div>
    </div>
  </div>
</template>

<script>
import { getFairy, bindDevice } from '@/apiv4/fairy'
export default {
  components: {  },
  data() {
    return {
      fId: 0,
      code: '',
      fairy: {}
    }
  },
  async created() {
    
  },
  mounted() {
    this.fId = this.$route.query.fid
    if (!this.fId) {
      this.$toast.show({ text: '获取精灵信息失败，请稍后重试', duration: 20000 })
    }
    this.getFairy()
  },
  methods: {
    async getFairy() {
      let fairyRes = await getFairy(this.fId)
      this.fairy = fairyRes.data.fairy
    },
    async submit() {
      if (!this.code.length) {
        this.$toast.show({ text: '请填写绑定码', duration: 2000 })
        return
      } else {
        try {
          await bindDevice(this.fId, this.code)
          this.$toast.show({ text: '绑定成功！', duration: 2000 })
          this.$router.push({ path: 'spirit' })
        } catch (err) {
          this.$toast.show({ text: '绑定失败，请检查绑定码是否输入正确', duration: 3000 })
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";
.container {
  height: 100%;
  min-height: 100vh;
  background: #f4f4f8;
}

.detail {
  display: flex;
  padding: 5.3vw;
  padding-bottom: 2vw;
  background: #fff;
  .pic {
    display: block;
    min-width: 33.33vw;
    width: 33.33vw;
    height: 33.33vw;
    border: 1px solid rgba(0,0,0,0.1);
  }
  .instruction {
    padding-left: 3.73vw;
    .title {
      margin-bottom: 2.6vw;
      font-size: 3.73vw;
      color: #604038;
    }
    .intro {
      text-align: justify;
      font-size: 3.46vw;
      color: #717171;
      line-height: 1.6;
    }
  }
}

.bind {
  display: flex;
  padding: 5.3vw;
  padding-top: 2vw;
  background: #fff;
  .code-input {
    display: block;
    flex: 1;
    padding: 0 4vw;
    height: 8.53vw;
    background: #f4f4f8;
    border: none;
    border-radius: .4vw;
    outline: none;
  }
  .submit {
    display: block;
    margin-left: 2.66vw;
    width: 24vw;
    min-width: 24vw;
    height: 8.53vw;
    line-height: 8.53vw;
    text-align: center;
    border-radius: 1.06vw;
    background: #fedc42;
    color: #604038;
    font-size: 3.73vw;
  }
}

</style>
